<template>
  <div class="container_DemandarForm">
    <ValidationObserver ref="formDemandar">
      <b-form>
        <div v-if="!phase5" class="form_DemandarForm">
          <b-row>
            <b-col
              md="7"
              lg="7"
              class="separator"
              :class="phase1 || phase2 || phase3 || phase4 ? '' : 'invisible'"
            >
              <div class="pl-2 pr-2">
                <b-card-title>{{ $t("label.creacion.demanda") }}</b-card-title>

                <!-- Phase 1 -->
                <b-row class="mt-5" v-if="phase1">
                  <b-col cols="1">
                    <b-button disabled pill variant="primary" class="btn-number font-weight-bold"
                      >1</b-button
                    >
                  </b-col>
                  <b-col lg="5" md="5">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="'required'"
                      immediate
                      name="select-client"
                    >
                      <b-form-group>
                        <multiselect
                          id="select-client"
                          name="select-client"
                          aria-describedby="select-client-feedback"
                          :state="errors[0] ? false : null"
                          :class="errors[0] ? 'is-invalid' : ''"
                          :options="getClientesAll"
                          v-model="clienteSelected"
                          label="desCliente"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :multiple="false"
                          :preserve-search="false"
                          select-label=""
                          deselect-label=""
                          selected-label=""
                          :placeholder="$t('label.cliente')"
                          track-by="id"
                          @input="clienteSelectedInput"
                        >
                          <span slot="noOptions">{{ $t("text.no.options") }}</span>
                          <span slot="noResult">{{ $t("text.no.results") }}</span>
                        </multiselect>
                        <b-form-invalid-feedback id="select-client-feedback">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="5" md="5">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="{ required: clienteSelected !== null && delegationSelected === null }"
                      immediate
                      name="select-delegation"
                    >
                      <b-form-group>
                        <multiselect
                          id="select-delegation"
                          name="select-delegation"
                          aria-describedby="select-delegation-feedback"
                          :state="errors[0] ? false : null"
                          :class="errors[0] ? 'is-invalid' : ''"
                          :options="delegations"
                          v-model="delegationSelected"
                          label="desDelegacion"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :multiple="false"
                          :preserve-search="false"
                          select-label=""
                          deselect-label=""
                          selected-label=""
                          :placeholder="$t('label.delegacion')"
                          track-by="id"
                        >
                          <span slot="noOptions">{{ $t("text.no.options") }}</span>
                          <span slot="noResult">{{ $t("text.no.results") }}</span>
                        </multiselect>
                        <b-form-invalid-feedback id="select-delegation-feedback">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="phase1 && clienteSelected?.pais.hasTransportadora">
                  <b-col cols="1"> </b-col>
                  <b-col lg="5" md="5">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="'required'"
                      immediate
                      name="select-transportadora"
                    >
                      <b-form-group>
                        <multiselect
                          id="select-transportadora"
                          name="select-transportadora"
                          aria-describedby="select-transportadora-feedback"
                          :state="errors[0] ? false : null"
                          :class="errors[0] ? 'is-invalid' : ''"
                          :options="transportadorasOptions"
                          v-model="transportadoraSelected"
                          label="descripcion"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :multiple="false"
                          :preserve-search="false"
                          select-label=""
                          deselect-label=""
                          selected-label=""
                          :placeholder="$t('label.transportadora')"
                          track-by="id"
                        >
                          <span slot="noOptions">{{ $t("text.no.options") }}</span>
                          <span slot="noResult">{{ $t("text.no.results") }}</span>
                        </multiselect>
                        <b-form-invalid-feedback id="select-transportadora-feedback">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="
                    phase1 && delegationSelected && clienteSelected?.pais.intercambioDelegaciones
                  "
                >
                  <b-col cols="1"></b-col>
                  <b-col lg="10" md="10">
                    <div class="label_TitleLeftToDelegacionesOpcionales">
                      {{ titleLeftToDelegacionesOpcionales }}
                    </div>
                    <PFormSelectTranslateItems
                      v-model="delegationsOptional"
                      :options="delegationsOptionalFiltered"
                      optionValue="id"
                      optionText="desDelegacion"
                      :titleRight="$t('label.seleccionados')"
                      :titleLeft="$t('label.delegacion')"
                    ></PFormSelectTranslateItems>
                  </b-col>
                </b-row>
                <b-row class="mb-5" v-if="phase1">
                  <b-col cols="1"> </b-col>
                  <b-col lg="11" md="11" v-if="clienteSelected">
                    <span class="recent-label">{{ $t("label.divisa") }}</span>
                    <b-row>
                      <b-col>
                        <b-form-group v-if="clienteSelected">
                          <b-form-radio-group
                            v-model="divisaSelected"
                            buttons
                            button-variant="outline-primary"
                            class="mx-n1 radio-form-group"
                          >
                            <template v-for="divisa in divisas">
                              <b-form-radio
                                :value="divisa"
                                :key="divisa.id"
                                class="mx-1 form-radio"
                              >
                                {{ divisa.simbolo }} {{ divisa.codDivisa }}
                              </b-form-radio>
                            </template>
                          </b-form-radio-group>
                          <br />
                          <span
                            class="error-divisa"
                            v-if="clienteSelected && delegationSelected && !divisaSelected"
                            >{{ $t("validation.messages.required") }}</span
                          >
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- Phase 2 -->
                <b-row class="mt-5" v-if="phase2">
                  <b-col cols="1">
                    <b-button disabled pill variant="primary" class="btn-number font-weight-bold"
                      >2</b-button
                    >
                  </b-col>
                  <b-col lg="5" md="5" v-if="!clienteSelected?.fakeCerts">
                    <span class="recent-label">{{ $t("label.denominaciones.disponibles") }}</span>
                  </b-col>
                  <b-col lg="5" md="5">
                    <span class="recent-label">{{ $t("label.denominaciones.demandar") }}</span>
                  </b-col>
                </b-row>

                <b-row class="mt-3 mb-5" v-if="phase2">
                  <b-col v-if="!clienteSelected?.fakeCerts">
                    <b-card class="m-0">
                      <b-card-header>
                        <b-row>
                          <b-col>
                            <span class="recent-label">{{
                              $t("label.saldo.total.disponible")
                            }}</span>
                            <br />
                            <span class="recent-label font-weight-bold"
                              >{{ divisaSelected.simbolo }}
                              {{ Number(saldoDisponible).toLocaleString() }}</span
                            >
                            <b-icon
                              class="float-right mt-2"
                              icon="chevron-down"
                              v-b-toggle.card-body-denominaciones
                            ></b-icon>
                          </b-col>
                        </b-row>
                      </b-card-header>
                      <b-collapse
                        class="panel-denominaciones"
                        visible
                        id="card-body-denominaciones"
                      >
                        <b-card-text>
                          <b-row class="ma-1">
                            <b-col lg="6" md="6">
                              <b-card-title class="align-center">{{
                                $t("label.denominacion")
                              }}</b-card-title>
                            </b-col>
                            <b-col lg="6" md="6">
                              <b-card-title>{{ $t("label.disponible") }}</b-card-title>
                            </b-col>
                          </b-row>
                          <div v-for="detalleSaldo in detallesSaldo" :key="detalleSaldo.id">
                            <hr />
                            <b-row>
                              <b-col>
                                <span
                                  >{{
                                    detalleSaldo.calidadDenominacion.denominacion.codDenominacion
                                  }}
                                  {{ detalleSaldo.calidadDenominacion.desCalidad }}</span
                                >
                              </b-col>
                              <b-col>
                                <span>{{ Number(detalleSaldo.saldoActual).toLocaleString() }}</span>
                              </b-col>
                            </b-row>
                          </div>
                        </b-card-text>
                      </b-collapse>
                    </b-card>
                  </b-col>
                  <b-col>
                    <b-row class="mt-3">
                      <b-col>
                        <span class="recent-label">{{ $t("label.total.demandar") }}</span>
                        <br />
                        <span class="recent-label font-weight-bold"
                          >{{ divisaSelected.simbolo }} {{ filterNumber(saldoDemandar, 2) }}</span
                        >
                      </b-col>
                    </b-row>
                    <b-row class="mt-3">
                      <b-col>
                        <ValidationProvider
                          v-slot="{ errors }"
                          :rules="'required'"
                          name="select-denominacion"
                        >
                          <b-form-group>
                            <multiselect
                              id="select-denominacion"
                              name="select-denominacion"
                              v-model="calidadesDenominacionSelected"
                              aria-describedby="select-denominacion-feedback"
                              :options="calidadesDenominacion"
                              :custom-label="customLabelDenominacion"
                              :clear-on-select="false"
                              :close-on-select="false"
                              :multiple="true"
                              :preserve-search="false"
                              select-label=""
                              deselect-label=""
                              selected-label=""
                              :state="errors[0] ? false : null"
                              :placeholder="$t('option.select')"
                              track-by="id"
                            >
                              <span slot="noOptions">{{ $t("text.no.options") }}</span>
                              <span slot="noResult">{{ $t("text.no.results") }}</span>
                              <template v-slot:option="{ option }">
                                <div>
                                  <span
                                    >{{ option.denominacion.codDenominacion }}
                                    {{ option.desCalidad }}</span
                                  >
                                </div>
                              </template>
                            </multiselect>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                    <b-row
                      class="mt-3"
                      v-if="
                        calidadesDenominacionSelected && calidadesDenominacionSelected.length > 0
                      "
                    >
                      <b-col>
                        <b-row>
                          <b-col lg="6" md="6">
                            <span class="recent-label">{{ $t("label.importe.demandar") }}</span>
                          </b-col>
                          <b-col lg="3" md="3" class="label-demandado">
                            <b-card-title>{{ $t("label.demandado") }}</b-card-title>
                          </b-col>
                          <b-col lg="3" md="3" class="label-demandado">
                            <b-card-title>{{ $t("label.cantidad") }}</b-card-title>
                          </b-col>
                        </b-row>
                        <div
                          v-for="(calidadDenominacion, index) in calidadesDenominacionSelected"
                          :key="calidadDenominacion.id"
                        >
                          <hr />
                          <b-row>
                            <b-col>
                              <span
                                >{{ calidadDenominacion.denominacion.codDenominacion }}
                                {{ calidadDenominacion.desCalidad }}</span
                              >
                            </b-col>
                            <b-col> </b-col>
                            <b-col mr="3">
                              <span
                                class="denominacion-importe float-right"
                                v-b-toggle="
                                  `calidadDenominacion-${calidadDenominacion.id.toString()}`
                                "
                                @click="
                                  (calidadDenominacion.importeSelected = true),
                                    (calidadDenominacion.cantidadSelected = false)
                                "
                                >{{ divisaSelected.simbolo }}
                                {{ filterNumber(calidadDenominacion.importe, 2) }}</span
                              >
                            </b-col>
                            <b-col mr="3">
                              <span
                                class="denominacion-importe float-right"
                                v-b-toggle="`cantidad-${calidadDenominacion.id.toString()}`"
                                @click="
                                  (calidadDenominacion.importeSelected = false),
                                    (calidadDenominacion.cantidadSelected = true)
                                "
                              >
                                {{ calidadDenominacion.cantidad }}</span
                              >
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col>
                              <ValidationProvider
                                v-slot="{ errors }"
                                :rules="`valid-denomination:${calidadDenominacion.denominacion.numValue}|min_value:0`"
                                :name="`cantidad-denominacion_${index}`"
                              >
                                <b-collapse
                                  :id="`calidadDenominacion-${calidadDenominacion.id.toString()}`"
                                  v-if="
                                    calidadDenominacion.importeSelected &&
                                    !calidadDenominacion.cantidadSelected
                                  "
                                >
                                  <b-card class="input-card">
                                    <b-card-body>
                                      <b-row>
                                        <b-col offset-lg="3" offset-md="3" lg="6" md="6">
                                          <b-form-group>
                                            <b-input
                                              type="number"
                                              min="0"
                                              max="999999999"
                                              :step="calidadDenominacion.denominacion.numValue"
                                              v-model="calidadDenominacion.importe"
                                              :name="`cantidad-denominacion_${index}`"
                                              :id="`cantidad-denominacion_${index}`"
                                              :state="errors[0] ? false : null"
                                              :aria-describedby="`cantidad-denominacion-feedback_${index}`"
                                              @change="calculaCantidad(calidadDenominacion)"
                                            />
                                          </b-form-group>
                                        </b-col>
                                      </b-row>
                                      <b-input
                                        type="range"
                                        min="0"
                                        max="999999999"
                                        :step="calidadDenominacion.denominacion.numValue"
                                        v-model="calidadDenominacion.importe"
                                        class="mt-1"
                                        @click="calculaCantidad(calidadDenominacion)"
                                      />
                                    </b-card-body>
                                  </b-card>
                                </b-collapse>
                                <b-form-invalid-feedback
                                  :id="`cantidad-denominacion-feedback_${index}`"
                                  class="d-block"
                                >
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </ValidationProvider>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col>
                              <ValidationProvider
                                v-slot="{ errors }"
                                :rules="`min_value:0|integer`"
                                :name="`cantidad_${index}`"
                              >
                                <b-collapse
                                  :id="`cantidad-${calidadDenominacion.id.toString()}`"
                                  v-if="
                                    !calidadDenominacion.importeSelected &&
                                    calidadDenominacion.cantidadSelected
                                  "
                                >
                                  <b-card class="input-card">
                                    <b-card-body>
                                      <b-row>
                                        <b-col offset-lg="3" offset-md="3" lg="6" md="6">
                                          <b-form-group>
                                            <b-input
                                              type="number"
                                              min="0"
                                              max="1666666"
                                              :step="1"
                                              v-model="calidadDenominacion.cantidad"
                                              :name="`cantidad_${index}`"
                                              :id="`cantidad_${index}`"
                                              :state="errors[0] ? false : null"
                                              :aria-describedby="`cantidad-feedback_${index}`"
                                              @change="calculaImporte(calidadDenominacion)"
                                            />
                                          </b-form-group>
                                        </b-col>
                                      </b-row>
                                      <b-input
                                        type="range"
                                        min="0"
                                        max="1666666"
                                        :step="1"
                                        v-model="calidadDenominacion.cantidad"
                                        class="mt-1"
                                        @click="calculaImporte(calidadDenominacion)"
                                      />
                                    </b-card-body>
                                  </b-card>
                                </b-collapse>
                                <b-form-invalid-feedback
                                  :id="`cantidad-feedback_${index}`"
                                  class="d-block"
                                >
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </ValidationProvider>
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- Phase 3 -->
                <b-row class="mt-5" style="margin-bottom: 5rem" v-if="phase3">
                  <b-col>
                    <b-row>
                      <b-col cols="1">
                        <b-button
                          disabled
                          pill
                          variant="primary"
                          class="btn-number font-weight-bold"
                          >3</b-button
                        >
                      </b-col>
                      <b-col lg="5" md="5">
                        <ValidationProvider
                          v-slot="{ errors }"
                          :rules="'required'"
                          name="select-fecha-expiracion"
                        >
                          <b-form-group>
                            <label class="recent-label" for="select-fecha-expiracion">
                              {{ $t("label.fecha.expiracion") }}
                            </label>
                            <b-form-datepicker
                              id="select-fecha-expiracion"
                              name="select-fecha-expiracion"
                              v-model="fechaExpiracion"
                              :state="errors[0] ? false : null"
                              aria-describedby="fecha-expiracion-feedback"
                              type="date"
                              :min="
                                new Date(
                                  new Date().getFullYear(),
                                  new Date().getMonth(),
                                  new Date().getDate()
                                )
                              "
                              :date-format-options="{
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                              }"
                            />
                            <b-form-invalid-feedback id="fecha-expiracion-feedback">
                              {{ errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                    <b-row class="mt-4">
                      <b-col cols="1"> </b-col>
                      <b-col lg="5" md="5">
                        <ValidationProvider
                          v-slot="{ errors }"
                          :rules="'required|date_future'"
                          name="select-hora-expiracion"
                        >
                          <b-form-group>
                            <label class="recent-label d-block" for="select-hora-expiracion">
                              {{ $t("label.hora.expiracion") }}
                            </label>
                            <b-time
                              id="select-hora-expiracion"
                              name="select-hora-expiracion"
                              v-model="horaExpiracion"
                              :state="errors[0] ? false : null"
                              aria-describedby="fecha-hora-feedback"
                              :hide-header="true"
                              :class="errors[0] ? 'is-invalid' : null"
                            />
                            <b-form-invalid-feedback id="fecha-hora-feedback">
                              {{ errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                    <b-row class="mt-4">
                      <b-col cols="1"> </b-col>
                      <b-col>
                        <label class="recent-label" for="radio-coste">
                          {{ $t("label.coste") }}
                        </label>
                      </b-col>
                      <b-col v-if="clienteSelected?.pais.hasTasa">
                        <label class="recent-label" for="select-tasa">
                          {{ $t("label.tasa") }}
                        </label>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"> </b-col>
                      <b-col>
                        <b-form-group>
                          <b-form-radio-group
                            v-model="costeSelected"
                            buttons
                            button-variant="outline-primary"
                            class="mx-n1"
                            id="radio-coste"
                          >
                            <template v-for="coste in getCostes">
                              <b-form-radio :value="coste" :key="coste.id" class="mx-1">
                                {{ coste.codParametro }}
                              </b-form-radio>
                            </template>
                          </b-form-radio-group>
                        </b-form-group>
                      </b-col>
                      <b-col v-if="clienteSelected?.pais.hasTasa">
                        <ValidationProvider
                          v-slot="{ errors }"
                          :rules="'between:0,100|required'"
                          name="select-tasa"
                        >
                          <b-form-group>
                            <b-input-group append="%" :class="errors[0] ? 'is-invalid' : null">
                              <b-form-input
                                id="select-tasa"
                                type="number"
                                append="%"
                                min="0"
                                max="100"
                                step="0.00001"
                                v-model="tasa"
                                name="select-tasa"
                                :state="errors[0] ? false : null"
                                aria-describedby="tasa-feedback"
                              ></b-form-input>
                            </b-input-group>
                            <b-form-invalid-feedback id="tasa-feedback">
                              {{ errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                    <b-row class="mt-4">
                      <b-col cols="1"> </b-col>
                      <b-col v-if="clienteSelected?.pais.admiteAnonimo">
                        <b-form-group>
                          <div class="custom-control custom-switch">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              id="inputAnonimo"
                              v-model="anonimo"
                            />
                            <label class="custom-control-label" for="inputAnonimo">{{
                              $t("label.demanda.anonima")
                            }}</label>
                          </div>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group>
                          <div class="custom-control custom-switch">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              id="inputParcial"
                              v-model="parcial"
                            />
                            <label class="custom-control-label" for="inputParcial">{{
                              $t("label.demanda.parcial")
                            }}</label>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- Phase 4 -->
                <b-row class="mt-4" style="margin-bottom: 5rem" v-if="phase4">
                  <b-col>
                    <div v-if="isShowBankField">
                      <b-row>
                        <b-col cols="1">
                          <b-button
                            disabled
                            pill
                            variant="primary"
                            class="btn-number font-weight-bold"
                            >4</b-button
                          ></b-col
                        >
                        <b-col lg="10" md="10" class="">
                          <ValidationProvider
                            v-slot="{ errors }"
                            rules="required|max:14|cuenta_corriente_pattern"
                            name="cuentaCorriente"
                          >
                            <b-form-group>
                              <span class="recent-label">{{ $t("label.cuentaCorriente") }}</span>
                              <b-row class="mt-10">
                                <b-input
                                  id="cuentaCorriente"
                                  name="cuentaCorriente"
                                  v-model="demandaPaso4Params.cuentaCorriente"
                                  aria-describedby="cuenta_corriente-feedback"
                                  type="text"
                                  class="w-50"
                                  :class="errors[0] ? 'is-invalid' : ''"
                                  :state="errors[0] ? false : null"
                                />
                                <b-form-invalid-feedback id="cuenta_corriente-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-row>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="1"></b-col>
                        <b-col lg="10" md="10" class="">
                          <ValidationProvider
                            v-slot="{ errors }"
                            rules="required|max:11|ag_numero_sucursal_pattern"
                            name="agNumeroSucursal"
                          >
                            <b-form-group>
                              <span class="recent-label">{{ $t("label.agNumeroSucursal") }}</span>

                              <b-row class="mt-10">
                                <b-input
                                  id="agNumeroSucursal"
                                  name="agNumeroSucursal"
                                  v-model="demandaPaso4Params.agNumeroSucursal"
                                  aria-describedby="ag_numero_sucursal-feedback"
                                  type="text"
                                  class="w-50"
                                  :class="errors[0] ? 'is-invalid' : ''"
                                  :state="errors[0] ? false : null"
                                />
                                <b-form-invalid-feedback id="ag_numero_sucursal-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-row>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="1"></b-col>
                        <b-col lg="10" md="10" class="">
                          <ValidationProvider
                            v-slot="{ errors }"
                            rules="required|length:11|numeric"
                            name="ispbBanco"
                          >
                            <b-form-group>
                              <span class="recent-label">{{ $t("label.ispbBanco") }}</span>
                              <b-row class="mt-10">
                                <b-input
                                  id="ispbBanco"
                                  name="ispbBanco"
                                  v-model="demandaPaso4Params.ispbBanco"
                                  aria-describedby="ispb_banco-feedback"
                                  type="text"
                                  class="w-50"
                                  :class="errors[0] ? 'is-invalid' : ''"
                                  :state="errors[0] ? false : null"
                                />
                                <b-form-invalid-feedback id="ispb_banco-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-row>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="1"></b-col>
                        <b-col lg="10" md="10" class="">
                          <ValidationProvider
                            v-slot="{ errors }"
                            rules="required|max:18|cnpj_persona_pattern"
                            name="cnpjPersona"
                          >
                            <b-form-group>
                              <span class="recent-label">{{ $t("label.cnpjPersona") }}</span>
                              <b-row class="mt-10">
                                <b-input
                                  id="cnpjPersona"
                                  name="cnpjPersona"
                                  v-model="demandaPaso4Params.cnpjPersona"
                                  aria-describedby="cnpj_persona-feedback"
                                  type="text"
                                  class="w-50"
                                  :class="errors[0] ? 'is-invalid' : ''"
                                  :state="errors[0] ? false : null"
                                />
                                <b-form-invalid-feedback id="cnpj_persona-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-row>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                    </div>
                    <b-row>
                      <b-col cols="1"> </b-col>
                      <b-col lg="10" md="10" class="">
                        <b-form-group>
                          <span class="recent-label">{{ $t("label.observaciones") }}</span>
                        </b-form-group>
                        <b-row class="mt-10">
                          <textarea
                            class="textarea"
                            id="observacionesOferta"
                            v-model="demandaPaso4Params.observacionesDemanda"
                            name="observacionesOferta"
                            type="text"
                          />
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- Phase 5 -->
                <b-row class="mt-5" v-if="phase5"> </b-row>

                <b-row v-if="!phase5" class="modal-transferencias-footer">
                  <b-col v-if="!phase1">
                    <b-button
                      pill
                      variant="outline-primary"
                      class="p-button-secondary"
                      @click="atras"
                    >
                      {{ $t("label.atras") }}
                    </b-button>
                  </b-col>
                  <b-col>
                    <b-button
                      pill
                      variant="primary"
                      class="p-button-primary"
                      :disabled="continuarCondition"
                      @click="continuar"
                    >
                      {{ $t("label.continuar") }}
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col md="5" lg="5">
              <div class="pl-2 pr-3">
                <resumen-demanda
                  :cliente="clienteSelected"
                  :delegacion="delegationSelected"
                  :transportadora="transportadoraSelected"
                  :divisa="divisaSelected"
                  :calidadesDenominacion="calidadesDenominacionSelected"
                  :saldoDemandar="saldoDemandar"
                  :fechaExpiracion="fechaExpiracion"
                  :horaExpiracion="horaExpiracion"
                  :coste="costeSelected"
                  :anonimo="anonimo"
                  :parcial="parcial"
                  :tasa="tasa"
                  :demandaPaso4Params="demandaPaso4Params"
                  :final="phase5"
                ></resumen-demanda>
                <div v-if="phase5">
                  <b-row class="mt-5">
                    <b-col class="text-right">
                      <b-button
                        pill
                        variant="outline-primary"
                        class="p-button-secondary mr-4"
                        @click="atras"
                      >
                        {{ $t("label.modificar") }}
                      </b-button>
                      <b-button
                        pill
                        variant="primary"
                        class="p-button-primary"
                        @click="infoDemandar"
                      >
                        {{ $t("label.demandar") }}
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>

        <div v-if="phase5">
          <PConfirm :textButtonAccept="$t('label.demandar')" @accept="demandar" @cancel="cancelar">
            <template #title>
              <span class="label-21">
                {{ $t("label.solicitar.fondos") }}
                <span class="font-weight-bold"> {{ delegationSelected.desDelegacion }}</span>
              </span>
            </template>
            <template #description>
              {{ $t("label.aviso.demanda") }}
            </template>
            <template #content>
              <PDataLine
                v-if="divisaSelected"
                :value="{
                  saldoDemandar:
                    divisaSelected.simbolo +
                    ' ' +
                    Number(saldoDemandar)
                      .toFixed(2)
                      .replace('.', ',')
                      .replace(/\d(?=(\d{3})+\,)/g, '$&.')
                      .toLocaleString(),
                }"
                :fields="{
                  saldoDemandar: { title: $t('label.total.demandar') },
                }"
                :widthContent="true"
              >
              </PDataLine>
            </template>
          </PConfirm>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import ResumenDemanda from "./ResumenDemanda.vue";
import {
  ICalidadDenominacion,
  ICliente,
  IDelegacion,
  IDenominacion,
  IDetallesSaldo,
  IDivisa,
  IParametro,
  ISaldo,
  ITransportadora,
} from "@/entities";
import Multiselect from "vue-multiselect";
import { Action, Getter } from "vuex-class";
import {
  IDemandaParams,
  IDemandaPaso4Params,
  IDetalleDemandaParams,
  ISaldoActualParams,
} from "@/services";
import { EventBus } from "@/event-bus";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import AsyncComputed from "vue-async-computed-decorator";
import VueMethods from "@/vue-methods";
import VueFilters from "@/vue-filters";
import * as mathjs from "mathjs";

@Component({
  name: "demandar-form",
  mixins: [VueMethods, VueFilters],
  components: {
    ResumenDemanda,
    Multiselect,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class DemandarForm extends Vue {
  @Action("fetchSaldoActual") fetchSaldoActual!: (
    params?: ISaldoActualParams
  ) => Promise<ISaldo | undefined>;
  @Getter("getClienteSelected") getClienteSelected!: ICliente;
  @Getter("getClientesAll") getClientesAll!: ICliente[];
  @Getter("getCostes") getCostes!: IParametro[];

  $refs!: {
    formDemandar: InstanceType<typeof ValidationObserver>;
  };

  public phase1 = true;
  public phase2 = false;
  public phase3 = false;
  public phase4 = false;
  public phase5 = false;

  public clienteSelected: ICliente | null = null;
  public delegationSelected: IDelegacion | null = null;
  public transportadoraSelected: ITransportadora | null = null;
  public divisaSelected: IDivisa | null = null;

  public saldoActual: ISaldo | null = null;
  public denominaciones: IDenominacion[] | undefined = [];
  public calidadesDenominacionSelected: ICalidadDenominacion[] | undefined = [];
  public detallesSaldo: IDetallesSaldo[] | undefined = [];
  public saldoDisponible: number | undefined = 0;
  public transportadorasOptions: ITransportadora[] | null = [];

  public costeSelected: IParametro | null = null;
  public fechaExpiracion: string | null = null;
  public horaExpiracion: string | null = null;
  public anonimo = false;
  public parcial = false;
  public tasa: number | undefined = 0;
  isShowBankField = false;

  delegationsOptional: number[] = [];

  demandaPaso4Params: IDemandaPaso4Params = {
    relleno: false,
    cuentaCorriente: "",
    agNumeroSucursal: "",
    ispbBanco: "",
    cnpjPersona: "",
    observacionesDemanda: "",
  };

  get delegationsOptionalFiltered(): IDelegacion[] {
    return this.delegations.filter((del) => del.id != this.delegationSelected?.id);
  }

  get delegationsOptionalSelected(): number[] {
    return this.delegationsOptional.filter((id) => id != this.delegationSelected?.id);
  }

  get divisas(): IDivisa[] {
    return this.clienteSelected?.divisas ?? [];
  }

  async searchTransportadoras(): Promise<void> {
    if (this.clienteSelected?.pais.hasTransportadora) {
      const res = await this.$services.transportadoras.fetchAllTransportadoras(
        this.clienteSelected.pais.codPaisCorto
      );
      if (res) {
        this.transportadorasOptions = res;
      }
    }
  }

  async mounted(): Promise<void> {
    extend("date_future", {
      validate: async () => {
        if (this.fechaExpiracion && this.horaExpiracion) {
          return (
            new Date(
              Number(this.fechaExpiracion.split("-")[0]),
              Number(this.fechaExpiracion.split("-")[1]) - 1,
              Number(this.fechaExpiracion.split("-")[2]),
              Number(this.horaExpiracion.split(":")[0]),
              Number(this.horaExpiracion.split(":")[1])
            ) > new Date()
          );
        }
        return false;
      },
      message: () => this.$t("validation.messages.date_must_future"),
    });

    this.clienteSelected = this.getClienteSelected;
    await this.searchTransportadoras();
  }

  get delegations(): IDelegacion[] {
    const d: IDelegacion[] = [];

    if (this.clienteSelected?.clientexdels) {
      this.clienteSelected?.clientexdels?.forEach((clientexdel) => {
        if (clientexdel?.delegacion && clientexdel.active) {
          d.push(clientexdel.delegacion);
        }
      });
      return d.sort((a, b) => this.sortAscending(a, b, "desDelegacion"));
    }
    return [];
  }

  async clienteSelectedInput(): Promise<void> {
    let aux = await this.$services.clientes._fetchCliente(Number(this.clienteSelected?.id));
    if (aux) {
      this.clienteSelected = aux;
      this.isShowBankField = aux.pais.hasInfoBancaria;
    }
    this.delegationSelected = null;
    this.divisaSelected = null;
    this.transportadoraSelected = null;
    await this.searchTransportadoras();
  }

  get calidadesDenominacion(): ICalidadDenominacion[] {
    const calidades: ICalidadDenominacion[] = [];
    const denominaciones = Object.assign([], this.divisaSelected?.denominaciones);
    denominaciones?.sort((a, b) => this.sortDescending(a, b, "numValue"));
    denominaciones?.forEach((denominacion: IDenominacion) => {
      denominacion.calidades?.forEach((calidad) => {
        if (calidad) {
          this.$set(calidad, "importe", 0);
          this.$set(calidad, "importeSelected", false);
          this.$set(calidad, "cantidad", 0);
          this.$set(calidad, "cantidadSelected", false);
          calidades.push(calidad);
        }
      });
    });
    return calidades;
  }

  async searchSaldosActuales(): Promise<void> {
    if (this.clienteSelected && this.delegationSelected && this.divisaSelected) {
      const res = await this.fetchSaldoActual({
        pkCliente: this.clienteSelected.id!,
        pkDelegacion: this.delegationSelected.id,
        pkDivisa: this.divisaSelected.id,
      });
      if (res) {
        this.saldoActual = res;
        if (this.saldoActual) {
          this.saldoDisponible = this.saldoActual.saldoActual;
          this.detallesSaldo = this.saldoActual.detallesSaldo;
          this.denominaciones = this.saldoActual.divisa.denominaciones;
          this.denominaciones.forEach((denominacion) => {
            denominacion.calidades.forEach((calidad) => {
              if (calidad) {
                this.$set(calidad, "importe", 0);
                this.calidadesDenominacion?.push(calidad);
              }
            });
          });
        }
      } else {
        EventBus.$emit("p-toast", { variant: "danger", message: res });
      }
    }
  }

  fechaDefecto(): void {
    let currentDate = new Date();
    const currentDateIn17Hours = new Date();
    currentDateIn17Hours.setHours(17);
    currentDateIn17Hours.setMinutes(0);

    if (currentDate.getTime() > currentDateIn17Hours.getTime()) {
      currentDate.setDate(currentDate.getDate() + 1);
    }

    this.fechaExpiracion = `${currentDate.getFullYear()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getDate()}`;

    this.horaExpiracion = this.clienteSelected?.expirationTime ?? "17:00:00";
  }

  customLabelDenominacion(denominacion: ICalidadDenominacion): string {
    return denominacion?.denominacion?.codDenominacion + " " + denominacion?.desCalidad;
  }

  get saldoDemandar(): number {
    let sumaImportes = 0;
    this.calidadesDenominacionSelected?.forEach((calidadDenominacion) => {
      if (calidadDenominacion.importe) {
        sumaImportes = Number(sumaImportes) + Number(calidadDenominacion.importe);
      }
    });

    return sumaImportes;
  }

  get contieneImporte(): boolean {
    return !this.calidadesDenominacionSelected?.some((calidad) => calidad.importe == 0);
  }

  @AsyncComputed()
  async continuarCondition(): Promise<boolean> {
    if (this.phase1) {
      return false;
    } else if (this.phase2) {
      if (
        this.saldoDemandar > 0 &&
        this.contieneImporte &&
        this.calidadesDenominacionSelected &&
        this.calidadesDenominacionSelected?.length > 0 &&
        (await this.$refs.formDemandar.validate())
      ) {
        return false;
      }
    } else if (this.phase3) {
      if (
        this.fechaExpiracion &&
        this.horaExpiracion &&
        this.costeSelected &&
        (await this.$refs.formDemandar.validate({ silent: true }))
      ) {
        return false;
      }
    } else if (this.phase4) {
      if (await this.$refs.formDemandar.validate({ silent: true })) {
        return false;
      }
    }

    return true;
  }

  atras(): void {
    if (this.phase2) {
      this.phase1 = true;
      this.phase2 = false;
      this.calidadesDenominacionSelected = [];
    } else if (this.phase3) {
      this.phase2 = true;
      this.phase3 = false;
      this.fechaExpiracion = null;
      this.horaExpiracion = null;
      this.costeSelected = null;
      this.anonimo = false;
      this.parcial = false;
    } else if (this.phase4) {
      this.phase3 = true;
      this.phase4 = false;
      this.limpiarDemandaPaso4();
    } else if (this.phase5) {
      this.phase4 = true;
      this.phase5 = false;
    } else if (!this.phase1 && !this.phase2 && !this.phase3 && !this.phase4 && !this.phase5) {
      this.phase5 = true;
    }
  }

  async continuar(): Promise<void> {
    if (this.phase1) {
      if ((await this.$refs.formDemandar.validate({ silent: true })) && this.divisaSelected) {
        this.phase1 = false;
        this.phase2 = true;
        if (!this.clienteSelected?.fakeCerts) {
          await this.searchSaldosActuales();
        }
      }
    } else if (this.phase2) {
      this.phase2 = false;
      this.phase3 = true;
      this.fechaDefecto();
    } else if (this.phase3) {
      this.phase3 = false;
      this.phase4 = true;
      this.demandaPaso4Params.relleno = true;
    } else if (this.phase4) {
      this.phase4 = false;
      this.phase5 = true;
    }
  }

  cancelar(): void {
    this.phase5 = false;
    this.phase4 = true;
  }

  infoDemandar(): void {
    this.phase1 = false;
    this.phase2 = false;
    this.phase3 = false;
    this.phase4 = false;
    this.phase5 = false;
  }

  limpiarDemandaPaso4(): void {
    this.demandaPaso4Params.cuentaCorriente = "";
    this.demandaPaso4Params.agNumeroSucursal = "";
    this.demandaPaso4Params.ispbBanco = "";
    this.demandaPaso4Params.cnpjPersona = "";
    this.demandaPaso4Params.observacionesDemanda = "";
    this.demandaPaso4Params.relleno = false;
  }

  async demandar(): Promise<void> {
    const detallesDemanda: IDetalleDemandaParams[] = [];
    this.calidadesDenominacionSelected?.forEach((calidadDenominacion) => {
      if (calidadDenominacion.importe > 0) {
        detallesDemanda.push({
          numCantidad: calidadDenominacion.importe,
          calidadDenominacion: calidadDenominacion,
        });
      }
    });
    if (
      this.clienteSelected &&
      this.delegationSelected &&
      this.divisaSelected &&
      this.costeSelected
    ) {
      const demandaParams: IDemandaParams = {
        numCantidad: this.saldoDemandar,
        fecExpirar: new Date(this.fechaExpiracion + " " + this.horaExpiracion),
        checkAnonimo: this.anonimo,
        checkParcial: this.parcial,
        coste: this.costeSelected.id,
        pkDivisa: this.divisaSelected.id,
        pkCliente: this.clienteSelected.id!,
        pkDelegacion: this.delegationSelected.id,
        pkTransportadora: this.transportadoraSelected ? this.transportadoraSelected.id : undefined,
        detallesDemanda: detallesDemanda,
        numTasa: this.clienteSelected.pais.hasTasa ? Number(this.tasa) : undefined,
        pkDelegaciones: this.delegationsOptionalSelected,
        observacionesDemanda: this.demandaPaso4Params.observacionesDemanda,
        cuentaCorriente: this.demandaPaso4Params.cuentaCorriente || undefined,
        agNumeroSucursal: this.demandaPaso4Params.agNumeroSucursal || undefined,
        ispbBanco: this.demandaPaso4Params.ispbBanco || undefined,
        cnpjPersona: this.demandaPaso4Params.cnpjPersona || undefined,
      };

      this.$emit("action", { action: "demandarConfirm", data: demandaParams });
    }
  }

  get titleLeftToDelegacionesOpcionales(): string {
    const textLeft = this.delegationSelected?.desDelegacion ?? "";
    const title = this.$t("label.delegaciones.opcionales.form").replace("X", textLeft);
    return this.$t(title);
  }

  calculaCantidad(calidadDenominacion?: ICalidadDenominacion): void {
    if (calidadDenominacion) {
      const result = mathjs.divide(
        calidadDenominacion.importe,
        calidadDenominacion.denominacion!.numValue
      );

      calidadDenominacion.cantidad = Number(mathjs.format(result, { precision: 14 }));
    }
  }

  calculaImporte(calidadDenominacion?: ICalidadDenominacion): void {
    if (calidadDenominacion) {
      const result = mathjs.multiply(
        calidadDenominacion.cantidad,
        calidadDenominacion.denominacion!.numValue
      );

      calidadDenominacion.importe = Number(mathjs.format(result, { precision: 14 }));
    }
  }
}
</script>

<style lang="scss" scoped>
.recent-label {
  font-size: 15px;
  line-height: 40px;
  color: var(--secundario-prosegur-claro);
}

.btn-number {
  border-color: transparent;
  background-color: #ffd102;
}

.separator {
  border-right-color: gainsboro;
  border-right-style: solid;
  border-right-width: 1px;
}

.carousel-transferencias {
  padding: 0 0.75rem;
}

.detalle-transferencias {
  padding-right: 0.5rem;
}

.card-body {
  margin: 0;
  padding: 0;
}

.card-header,
.card-text {
  padding: 1rem;
}

hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.input-card {
  margin: 1rem 0;
  padding: 1rem;
  border-radius: 6px;
  border: solid 0.7px #f1f0f0;
  background-color: rgba(255, 209, 2, 0.04);
}

.textarea {
  height: 150px;
  width: 100%;
  border-radius: 6px;
  border: solid 1px #ced4da;
}

.denominacion-importe {
  color: var(--amarillo-prosegur);
}

.modal-transferencias-footer {
  position: absolute;
  bottom: 0;
  right: 1rem;
}

.resumen {
  min-height: 13rem;
  margin: -2.6rem -1rem 2rem;
  background-color: var(--amarillo-prosegur);
}

.panel-denominaciones {
  overflow: auto;
  max-height: 55vh;
}
.btn-group-toggle::v-deep .btn-outline-primary {
  border-radius: 6px !important;
}
.resume-label {
  font-size: 13px;
  display: block;
  color: var(--secundario-prosegur-claro);
}
.label-15 {
  font-size: 15px;
  color: var(--secundario-prosegur-claro);
}
.label-17 {
  font-size: 17px;
  color: var(--secundario-prosegur-oscuro);
}
.label-21 {
  font-size: 17px;
  color: var(--secundario-prosegur-oscuro);
}
.label-demandado {
  display: flex;
  align-items: flex-end;
  justify-content: right;
}
.container_DemandarForm {
  min-height: 300px;
}
.form_DemandarForm {
  padding: 1rem;
}
.label_TitleLeftToDelegacionesOpcionales {
  line-height: 1.23;
  color: #6f6f6f;
  min-height: 16px;
  padding-bottom: 0.5rem;
  font-size: 12px;
  cursor: pointer;
}
.error-divisa {
  color: #dc3545;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
}
.radio-form-group {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
  flex-direction: row;
  flex-wrap: wrap;
}
.form-radio {
  flex: none !important;
  margin-bottom: 10px;
}
</style>
